import React from 'react';

import cx from 'classnames';
import { IconContext } from 'phosphor-react';

import { Minus, Plus } from 'components/shared/Icon/phosphorIcons';
import i18n from 'i18n';

import { useLandingV2Context } from '../../../../../context';
import { getPrefix } from '../../../../../utils';
import { ChildrenBlocksContent } from '../ChildrenBlocksContent';
import { useMoreDetails } from './functions';
import s from './index.module.css';

export const MoreDetails = () => {
  const { showDetails, setShowDetails, isDisabled } = useMoreDetails();
  const { readonly } = useLandingV2Context();

  if (readonly && isDisabled) return null;

  return (
    <div className={cx(s.wrapper, getPrefix('more-details'))}>
      <div
        className={cx(s.moreDetails, isDisabled && s.disabledMoreDetails)}
        onClick={() => {
          !isDisabled && setShowDetails(!showDetails);
        }}
      >
        <span data-block>{i18n.t('proposal_content.event_details.more_details')}</span>
        <IconContext.Provider
          value={{
            size: 22,
            className: s.plusIcon,
          }}
        >
          {showDetails ? <Minus /> : <Plus />}
        </IconContext.Provider>
      </div>
      <ChildrenBlocksContent isVisible={showDetails} />
    </div>
  );
};
